import { PseudoElementSelector } from "./pseudo-element.js";
/**
 * {@link https://drafts.csswg.org/css-pseudo-4/#placeholder-pseudo}
 */
export class Placeholder extends PseudoElementSelector {
    static of() {
        return new Placeholder();
    }
    constructor() {
        super("placeholder");
    }
    *[Symbol.iterator]() {
        yield this;
    }
}
(function (Placeholder) {
    Placeholder.parse = PseudoElementSelector.parseNonLegacy("placeholder", Placeholder.of);
})(Placeholder || (Placeholder = {}));
//# sourceMappingURL=placeholder.js.map